/* Animation Observer
  
  Observes classes with the class "animation-true" and determines when they intersect the viewport. 
  The animations trigger when initially viewed, and then replay everytime you scroll *down* to the element again.

*/

//observer
const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {

    //checks element for threshold data
    const thresholdData = entry.target.dataset.threshold;

    //checks the target elements for animation styling
    const animationData = entry.target.dataset.animate;
    
    //intersection logic
    if (entry.isIntersecting) {
      entry.target.classList.add(animationData);
    } else if (entry.boundingClientRect.top > 0) {
      // Scrolled back up past it
      entry.target.classList.remove(animationData);
    }
  });
}, { thresholdData : 0.1});

document.querySelectorAll('.animation-true')
  .forEach(el => observer.observe(el));
//end

/****** Toggle disclosure Text ******/
document.querySelectorAll('.read-more-button').forEach(button => {
  button.addEventListener('click', function() {

    //target text
    const targetText = ".text-block--"+ this.dataset.blockId;
    
    const lineNum = this.dataset.lineNum
    
    // const targetButton = "toggle-"
    const target = document.querySelector(targetText);

    
    toggle(target, this, lineNum)

  });
});

function toggle(el, btn,lineNum) {
  const expanded = el.style.maxHeight === el.scrollHeight + 'px';
  el.style.maxHeight = expanded ? 'calc('+lineNum+'* 1.6em)' : el.scrollHeight + 'px';
  el.style.maskImage = expanded ? 'linear-gradient(to bottom, black 80%, transparent 100%)' : 'none';
  el.style.webkitMaskImage = expanded ? 'linear-gradient(to bottom, black 80%, transparent 100%)' : 'none';
  btn.textContent = expanded ? 'Read more' : 'Show less';
}